import { render, staticRenderFns } from "./OrganizationAreaRow.vue?vue&type=template&id=4084eafd&scoped=true"
import script from "./OrganizationAreaRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationAreaRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OrganizationAreaRow.vue?vue&type=style&index=0&id=4084eafd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4084eafd",
  null
  
)

export default component.exports